<script setup>
import { useI18n } from 'vue-i18n';
import { useStore } from 'dashboard/composables/store';
import { useAlert, useTrack } from 'dashboard/composables';
import { CAMPAIGN_TYPES } from 'shared/constants/campaign.js';
import { CAMPAIGNS_EVENTS } from 'dashboard/helper/AnalyticsHelper/events.js';
import CampaignsAPI from 'dashboard/api/campaigns';

import WhatsAppCampaignForm from 'dashboard/components-next/Campaigns/Pages/CampaignPage/WhatsAppCampaign/WhatsAppCampaignForm.vue';

const emit = defineEmits(['close']);

const store = useStore();
const { t } = useI18n();

const addCampaign = async campaignDetails => {
  try {
    const response = await store.dispatch('campaigns/create', campaignDetails);
    const campaignId = response?.id || response?.display_id;

    useTrack(CAMPAIGNS_EVENTS.CREATE_CAMPAIGN, {
      type: CAMPAIGN_TYPES.ONE_OFF,
    });

    // Kampanyayı hemen başlat
    if (campaignId) {
      try {
        const triggerResponse = await CampaignsAPI.trigger(campaignId);
        const result = triggerResponse.data;

        if (result.audience_count > 0) {
          useAlert(`✅ Kampanya başlatıldı! ${result.audience_count} kişiye gönderiliyor...`);
        } else if (result.error) {
          useAlert(`⚠️ ${result.error}`);
        } else {
          useAlert('⚠️ Hedef kitlede kişi bulunamadı!');
        }
      } catch (triggerError) {
        console.error('Trigger error:', triggerError);
        const errorMsg = triggerError?.response?.data?.error || 'Bilinmeyen hata';
        useAlert(`⚠️ Kampanya başlatılamadı: ${errorMsg}`);
      }
    } else {
      useAlert(t('CAMPAIGN.WHATSAPP.CREATE.FORM.API.SUCCESS_MESSAGE'));
    }
  } catch (error) {
    const errorMessage =
      error?.response?.message ||
      t('CAMPAIGN.WHATSAPP.CREATE.FORM.API.ERROR_MESSAGE');
    useAlert(errorMessage);
  }
};

const handleSubmit = campaignDetails => {
  addCampaign(campaignDetails);
};

const handleClose = () => emit('close');
</script>

<template>
  <div
    class="w-[25rem] z-50 min-w-0 absolute top-10 ltr:right-0 rtl:left-0 bg-n-alpha-3 backdrop-blur-[100px] rounded-xl border border-n-weak shadow-md max-h-[80vh] overflow-y-auto"
  >
    <div class="p-6 flex flex-col gap-6">
      <h3 class="text-base font-medium text-n-slate-12 flex-shrink-0">
        {{ t(`CAMPAIGN.WHATSAPP.CREATE.TITLE`) }}
      </h3>
      <WhatsAppCampaignForm @submit="handleSubmit" @cancel="handleClose" />
    </div>
  </div>
</template>
